export const DISCOUNT_END_TIME_STORAGE_KEY = "discountEndTime";

export const TWO_DAYS_MS = 48 * 60 * 60 * 1000;

export const COUNTDOWN_INTERVAL = 1000;

export interface ITimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export interface IDiscountTimeParams {
    /** User's discount end date (from customData or session storage after claiming). */
    discountEndTime?: string;
}

export const ZERO_TIME_LEFT: ITimeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
};
